import { writable } from 'svelte/store';
import { ethers } from "ethers";

let provider;
let signer;

export const currentAddress = writable('0x0');
export let curIndex = writable(-1);
export let curAmount = writable(-1);
export const IsNetwork = writable(true);
export const Loading = writable(false);

export function getCurrentAddress() {
    let ca;
    currentAddress.subscribe(value => {
        if (value == '') {
            console.log('current address undefined');
            ca = null;
        }
        else {
            console.log('getCurrentAddress: ', value);
            ca = value;
        }
    });
    return ca;
}

export function boot() {
    // CurAddr = connectMetamask();
    provider = new ethers.providers.Web3Provider(window.ethereum, "any");
    connectWallet();
    provider.on("network", (newNetwork, oldNetwork) => {
        // When a Provider makes its initial connection, it emits a "network"
        // event with a null oldNetwork along with the newNetwork. So, if the
        // oldNetwork exists, it represents a changing network
        if (oldNetwork) {
            window.location.reload();
        }
    });
    ethereum.on('accountsChanged', function (accounts) {
        window.location.reload();
    })
    console.log("booted")
    
}

export async function connectWallet () {
    if(signer == null) {
        await provider.send("eth_requestAccounts", []);
        signer = provider.getSigner();
        const addr = await signer.getAddress();
        console.log("Account:", addr);
        currentAddress.update(n => addr);
        return addr;
    }
}

export async function addToken() {
    // placeholder function
    const tokenAddress = '0x3541a5c1b04adaba0b83f161747815cd7b1516bc';
    const tokenSymbol = 'KNIGHT';
    const tokenDecimals = 18;
    const tokenImage = 'https://s2.coinmarketcap.com/static/img/coins/64x64/17515.png';

    try {
    // wasAdded is a boolean. Like any RPC method, an error may be thrown.
        const wasAdded = await ethereum.request({
            method: 'wallet_watchAsset',
            params: {
            type: 'ERC20', // Initially only supports ERC20, but eventually more!
            options: {
                address: tokenAddress, // The address that the token is at.
                symbol: tokenSymbol, // A ticker symbol or shorthand, up to 5 chars.
                decimals: tokenDecimals, // The number of decimals in the token
                image: tokenImage, // A string url of the token logo
            },
            },
        });
        if (wasAdded) {
            console.log('Thanks for your interest!');
        } else {
            console.log('Your loss!');
        }
    } catch (error) {
        console.log(error);
    }
}
